<template>
    <modal :show="show" v-if="currentClient">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Add Users To {{ field }}</modal-header>
        </div>
        <list :key="confirmId" v-model="currentClient.users" :data="users" :currentIds="currentClient.users" />
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="Close" confirmText="Save"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {clientMixin} from '@/mixins/clientMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import ClientForm from '@/components/ClientForm/client-form'
import {modalMixin} from '@/mixins/modalMixin'
import List from '@/components/List/list'
import {userMixin} from '@/mixins/userMixin'
import {profileMixin} from '@/mixins/profileMixin'

export default {
  name: 'modal_client_confirm',
  mixins: [clientMixin, notificationMixin, modalMixin, userMixin, profileMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    ClientForm,
    List
  },
  props: {
    show: Boolean,
    confirmId: String,
    field: String
  },
  data: () => ({
    currentClient: null
  }),
  watch: {
    show () {
      this.monitorShow()
    }
  },
  created () {
    if (this.profileUser.role === 1) {
      this.getUsers()
    }
  },
  computed: {
  },
  methods: {
    monitorShow () {
      if (this.show) {
        this.startLoading()
        this.getClient(this.confirmId).then(() => {
          this.currentClient = this.client
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      } else {
        this.currentClient = null
      }
    },
    confirm () {
      this.startLoading()
      this.updateClient(this.currentClient).then(() => {
        const includeAssociatedUsers = 1
        this.getClients(includeAssociatedUsers).then(() => {
          this.$emit('addedUsers', this.client.users)
          this.addNotification('success', `'${this.client.name} client' Successfully updated.`)
          this.finishLoading()
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/clients/modal-assign-users.vue